import {useHistory} from '@aboutyou/router';

export const COUPON_PROMOTION_ID_QUERY_KEY = 'couponId';

export const useCouponPromotionIdFromQueryParams = () => {
  const history = useHistory();
  const queryParams = new URLSearchParams(history.location.search);
  return queryParams.get(COUPON_PROMOTION_ID_QUERY_KEY);
};
